module.exports = __webpack_public_path__ + "static/img/28.d858200.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/28.png
// module id = ec95
// module chunks = 0